import { gql } from '@apollo/client'

export const GET_POS_PRODUCT_INFO = gql`
  query GetPosProductInfo($upc: String!) {
    posProductInfo(upc: $upc) {
      upc
      description
      category
    }
  }
`
